module.exports = __webpack_public_path__ + "img/service_wechat_2.eb2e82fd.jpg";